// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'material-design-icons-iconfont/dist/material-design-icons.css' 
import Vue from 'vue'
import $ from 'jquery'
import Vuesax from 'vuesax'
import Vuetify from 'vuetify'
import './stylus/main.styl'

import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/fr'
import AmCharts from 'amcharts3'
import AmSerial from 'amcharts3/amcharts/serial'
import 'vuesax/dist/vuesax.css'

import DataTables from 'dataTable/data-tables.min.js'

import App from './App'
import Login from './components/Login'
import Routes from './components/Routes'
import router from './router'
import VueResource from 'vue-resource'
import contextMenu from 'vue-context-menu'
import VueAsyncData from 'vue-async-data'
import FullCalendar from 'vue-full-calendar'
import VueFilterDateFormat from 'vue-filter-date-format'

import ECharts from 'vue-echarts'
// import ECharts modules manually to reduce bundle size
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'// register component to use

//lightbox
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
Vue.use(CoolLightBox)


Vue.component('v-chart', ECharts)






//import * as VueGoogleMaps from "vue2-google-maps";




Vue.use(Vuetify)
Vue.use(VueResource)
Vue.use(ElementUI, { locale })

Vue.use(AmCharts)
Vue.use(AmSerial)
Vue.use(Vuesax)
Vue.use(contextMenu)
Vue.use(DataTables)
//Vue.use(DataTables)
Vue.use(FullCalendar)
Vue.use(VueAsyncData)
Vue.use(VueFilterDateFormat)
const moment = require('moment')
require('moment/locale/fr')
Vue.use(require('vue-moment'), {
    moment
});


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App, Login},
  render: function (createElement) {
    let session = sessionStorage.getItem('sessionUser')
    if(this.$router.history.current.name === "routes"){
      return createElement(Routes)
    }else{
      if (session) {
        return createElement(App)
      } else {
        return createElement(Login)
      }
    }
  
  },
    http: {
        root: '/root',
        headers: {
            Authorization: 'Basic YXBpOnBhc3N3b3Jk'
        }
    },
  mounted () {

  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    redirect () {
    }
  }

})



// WEBPACK FOOTER //
// ./src/main.js